import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import ServiceWrapper from './serviceWrapper';
import InputComponent from './inputComponent';
import styles from '../styles/configuration.module.scss';

function ArtifactoryConfig({ service, changeConfigurations, intialConfigs, storage }) {
    const { t } = useTranslation('configuration');

    const [isCheck, setIsCheck] = useState(intialConfigs.isCheck);
    const [isHidden, setIsHidden] = useState(true);
    const [ssd, setSsd] = useState(intialConfigs.ssd);

    useEffect(() => {
        changeConfigurations({ ssd, isCheck });
    }, [isCheck, ssd]);

    useEffect(() => {
        if (!isCheck) {
            setSsd(0);
        }
    }, [isCheck]);

    return (
        <ServiceWrapper service={service} changeActivity={value => setIsCheck(value)} value={isCheck}>
            <div className={'flex ' + styles.configs} onClick={() => setIsHidden(!isHidden)}>
                <div className={styles['arrow-container']}>
                    <div className={`${styles['arrow-element']} ${isHidden ? '' : styles['rotate-forward']}`} />
                </div>
                <p className={'pointer ' + styles.title}>{t('config')}</p>
            </div>
            <div className={`${styles[isHidden ? 'hide' : 'visible']} ${styles.options}`}>
                <InputComponent label={'disk.space'}
                            initial={ssd}
                            free={storage.free}
                            usable={storage.total}
                            setSpace={size => setSsd(size)}
                            available={isCheck} />
            </div>
        </ServiceWrapper>
    )
};

export default memo(ArtifactoryConfig);
